export default "__VITE_ASSET__0abb2b2d__"